import React, { Suspense, lazy, useState } from "react";
// import DescriptionSection from "./DescriptionSection";
import "./Portfolio.css";

const modalStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "fixed",
  zIndex: "50",
  left: "0",
  top: "0",
  width: "100%",
  height: "100%",
  overflow: "auto",
  backgroundColor: "rgba(0, 0, 0, 0.300)",
};

const modalContentStyle = {
  backgroundColor: "rgba(0, 0, 0, 0.1)",
  margin: "auto",
  borderRadius: "5px",
  padding: "5px",
  maxWidth: "50%",
};

const closeModalStyle = {
  color: "#aaa",
  float: "right",
  fontSize: "28px",
  fontWeight: "bold",
  cursor: "pointer",
};

function MenuItems({ menuItem, description }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  function openModal(image) {
    setSelectedImage(image);
    setModalIsOpen(true);
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  const LazyDescriptionSection = lazy(() => import("./DescriptionSection"));

  return (
    <div className="portfolios">
      {menuItem.map((item) => {
        return (
          <div className="portfolio new-portfolio" key={item.id}>
            <div className="image-data">
                <img
                  className="rounded portfolio-img"
                  src={item.image}
                  alt=""
                />
              {modalIsOpen && (
                <div style={modalStyle} onClick={closeModal}>
                  <div style={modalContentStyle}>
                    <span style={closeModalStyle} onClick={closeModal}>
                      &times;
                    </span>
                      <img src={selectedImage} alt="your-image" />
                  </div>
                </div>
              )}
              <ul className="hover-items">
                <li style={{ zIndex: 50 }}>
                  <span onClick={() => openModal(item.image)}>
                    <i className={item.icon1}></i>
                  </span>
                  <a href={item.link} target="_blank">
                    <span href={item.link}>
                      <i className={item.icon2}></i>
                    </span>
                  </a>
                </li>
              </ul>
              {/* <div className="hover-title"><h5>{item.title}</h5></div> */}
            </div>
            {description && (
              <Suspense fallback={<div>Loading...</div>}>
                <LazyDescriptionSection item={item} />
              </Suspense>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default MenuItems;
